module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc015ee6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-cleave/src/Cleave.vue
// module id = 787
// module chunks = 0